<template>
    <router-link :to="to"
        class="tw:flex tw:items-center tw:gap-2 tw:py-1.5 tw:px-3 tw:rounded-lg tw:text-sm tw:no-underline tw:transition-colors"
        :class="active
            ? 'tw:text-brand-primary tw:font-semibold tw:bg-brand-primary/10'
            : 'tw:text-slate-400 tw:hover:text-slate-200 tw:hover:bg-slate-800/40'">
        <i class="fa fa-hashtag tw:shrink-0"></i>
        <span class="tw:truncate"><slot></slot></span>
    </router-link>
</template>

<script>
export default {
    name: 'SidebarSubLink',
    props: {
        to: { type: [String, Object], required: true },
        active: { type: Boolean, default: false },
    },
}
</script>
